import { render, staticRenderFns } from "./VisitaAngiologicaList.vue?vue&type=template&id=4c27838e"
import script from "./VisitaAngiologicaList.vue?vue&type=script&lang=js"
export * from "./VisitaAngiologicaList.vue?vue&type=script&lang=js"
import style0 from "./VisitaAngiologicaList.vue?vue&type=style&index=0&id=4c27838e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports